import { getRandom } from './index'

export default class SocketService {
  static instance = null

  static get Instance() {
    if (!this.instance) {
      this.instance = new SocketService()
    }
    return this.instance
  }

  // 和服务端连接的socket对象
  ws = null
  // 存储回调函数
  callBackMapping = {}
  // 标识是否连接成功
  connected = false
  // token失效
  tokenIsYes = true
  // 记录重试的次数
  sendRetryCount = 0
  dataMsg = ''
  // 重新连接尝试的次数
  connectRetryCount = 0
  //  定义连接服务器的方法
  headers = ''
  token = null
  region = null
  retryTime = 5000 // 心跳重连时间
  connect(tokens, region) {
    this.token = tokens
    this.region = region
    // 连接服务器
    if (!window.WebSocket) {
      return console.error('您的浏览器不支持WebSocket')
    }
    let url = 'wss://log.cn.xmitech.net:2443'
    // let url = 'ws://192.168.99.248:8082'
    // let url = 'ws://192.168.50.208:8082'
    this.ws = new WebSocket(url)
    // 连接成功的事件
    this.ws.onopen = (e) => {
      console.log(e)
      console.error('连接服务端成功了')
      this.connected = true
      const data = {
        connect: 1
      }
      this.send(data)
    }
    // 1.连接服务端失败
    // 2.当连接成功之后, 服务器关闭的情况
    this.ws.onclose = () => {
      console.error('连接断开')
      this.connected = false
      // this.unRegisterCallBack('Message')
      if (this.tokenIsYes) {
        setTimeout(() => {
          console.error('尝试重新连接。。。。')
          this.connect(this.token, this.region)
        }, this.retryTime)
      }
      // else {
      //   ElMessageBox.confirm('您的登录已失效请重新登录', 'Warning', {
      //     confirmButtonText: '确认',
      //     cancelButtonText: '关闭',
      //     type: 'warning',
      //     center: true
      //   })
      //     .then(() => {
      //       store.dispatch('app/logout')
      //     })
      //     .catch(() => {
      //       store.dispatch('app/logout')
      //     })
      // }
    }
    // 得到服务端发送过来的数据
    this.ws.onmessage = (msg) => {
      console.log(JSON.parse(msg.data), '从服务端获取到了数据')
      if (JSON.parse(msg.data).code === 100401) {
        this.tokenIsYes = false
      } else {
        this.tokenIsYes = true
      }
      if (this.callBackMapping.Message) {
        this.callBackMapping.Message(msg.data)
      }
    }
  }

  // 回调函数的注册
  registerCallBack(socketType, callBack) {
    this.callBackMapping[socketType] = callBack
  }

  // 取消某一个回调函数
  unRegisterCallBack(socketType) {
    this.callBackMapping[socketType] = null
  }

  // 消息回复的回调

  // 发送数据的方法
  send(data) {
    // 判断此时此刻有没有连接成功
    console.log('连接状态', this.connected)
    if (this.connected) {
      const datas = {
        region: this.region,
        seq: getRandom(),
        headers: {
          Authorization: this.token
        },
        body: data
      }
      try {
        console.log('发送成功', datas)
        this.ws.send(JSON.stringify(datas))
      } catch (e) {
        this.ws.send(datas)
      }
    } else {
      setTimeout(() => {
        console.log('连接失败,重新连接')
        this.connect(this.token, this.region)
      }, this.retryTime)
    }
  }

  close(data) {
    console.error('关闭websocket')
    this.ws.close()
    // this.connected = false
  }
}
